var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    fillRule: "evenodd",
    d: "M4.677 2.366h-.59a.54.54 0 0 1 0-1.08h4.85a.54.54 0 1 1 0 1.08h-.59l.448 3.136q.338.188.635.434c.79.659 1.26 1.576 1.26 2.558a.54.54 0 0 1-.54.54H2.874a.54.54 0 0 1-.54-.54c0-.982.469-1.9 1.26-2.558l.345.415-.345-.415q.296-.246.634-.434zm1.091 0-.51 3.565a.54.54 0 0 1-.304.412 3 3 0 0 0-.668.423c-.407.34-.675.753-.797 1.188h6.046a2.4 2.4 0 0 0-.797-1.188 3 3 0 0 0-.668-.423.54.54 0 0 1-.304-.412l-.51-3.565z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.215,
    d: "M6.55 9.176v2.1"
  })));
};
export default SvgPin;